const whSquareValidator = (rule, value, callback) => {
    const reg = /^\d+(\.\d{1,2})?$/
    if (['', null, undefined].includes(value) || (reg.test(value) && Number(value) > 0 && Number(value) < 500000)) {
        callback()
    } else {
        callback(new Error('小于500000，大于0录入，支持2位小数'))
    }
}

const inputValidator = (rule, value, callback) => {
    const reg = /^\d{1,8}(\.\d{1,2})?$/
    if (value && !reg.test(value)) {
        callback(new Error('请输入8位正数，可保留2位小数'))
    } else {
        callback()
    }
}

// 支持负数且限制8位
const inputValidator2 = (rule, value, callback) => {
    const reg = /^-?\d{1,8}(\.\d{1,2})?$/
    if (value && !reg.test(value)) {
        callback(new Error('请输入8位数，可保留2位小数'))
    } else {
        callback()
    }
}

const whHeightValidator = (rule, value, callback) => {
    const reg = /^\d{1,3}(\.\d{1,2})?$/
    if (value && (!reg.test(value) || Number(value) === 0)) {
        callback(new Error('请输入3位正数，可保留2位小数'))
    } else {
        callback()
    }
}

const leaseTermValidator = (rule, value, callback) => {
    const reg = /^\d{1,3}(\.\d{1,2})?$/
    if (value && (!reg.test(value))) {
        callback(new Error('请输入3位正数，可保留2位小数或者输入0'))
    } else {
        callback()
    }
}

const specificPowerValidator = (rule, value, callback) => {
    const reg = /^\d{1,8}(\.\d{1,2})?$/
    if (value && (!reg.test(value) || Number(value) === 0)) {
        callback(new Error('请输入8位正数，可保留2位小数'))
    } else {
        callback()
    }
}

const cityDistanceValidator = (rule, value, callback) => {
    const reg = /^\d{1,3}(\.\d{1,2})?$/
    if (value && !reg.test(value)) {
        callback(new Error('请输入3位整数，可保留2位小数'))
    } else {
        callback()
    }
}

const fireUnitAreaValidator = (rule, value, callback) => {
    const reg = /^\d{1,6}(\.\d{1,2})?$/
    if (value && (!reg.test(value) || Number(value) === 0)) {
        callback(new Error('请输入6位正数，可保留2位小数'))
    } else {
        callback()
    }
}

export const rules = {
    whSquare: [
        { required: true, message: '请输入仓库建筑面积', trigger: ['blur', 'change'] },
        { validator: whSquareValidator, trigger: ['blur', 'change'] },
    ],
    usableArea: [
        { required: true, message: '请输入安得已租赁面积', trigger: ['blur', 'change'] },
        // { pattern: /^([1-9]\d{1,7}|\d)(\.\d{1,2})?$/, message: '请输入0-99999999.99', trigger: ['blur', 'change'] },
        { validator: inputValidator, trigger: ['blur', 'change'] },
    ],
    // // 可租面积改为置灰非必填&去除负数校验 20250714版本
    // rentableArea: [
    //     // { required: false, message: '请输入可租面积', trigger: ['blur', 'change'] },
    //     { validator: inputValidator, trigger: ['blur', 'change'] },
    // ],
    canopyWidth: [
        { required: false, message: '请输入雨棚宽度', trigger: ['blur', 'change'] },
        { validator: inputValidator, trigger: ['blur', 'change'] },
    ],
    workPortNumber: [
        { required: true, message: '请输入作业口数量', trigger: ['blur', 'change'] },
        { validator: inputValidator, trigger: ['blur', 'change'] },
    ],
    whAddress: [{ required: true, message: '请选择仓库地址', trigger: ['blur', 'change'] }],
    specialApproveFlag: [{ required: true, message: '请选择是否特批', trigger: ['blur', 'change'] }],
    whName: [
        { required: true, message: '请输入仓库名称', trigger: ['blur', 'change'] },
        { max: 20, message: '不能超过20个字符', trigger: ['blur', 'change'] },
    ],
    propertyType: [{ required: true, message: '请选择产权属性', trigger: ['blur', 'change'] }],
    leaseTerm: [{ validator: leaseTermValidator, trigger: ['blur', 'change'] },],
    // platformWarehouseFileUrl: [{ required: true, message: '请上传平台仓库方案评审', trigger: ['blur', 'change'] }],
    propertyOwner: [
        { required: true, message: '请输入产权人姓名', trigger: ['blur', 'change'] },
        { max: 20, message: '不能超过20个字符', trigger: ['blur', 'change'] },
    ],
    manageType: [{ required: true, message: '请选择管理属性', trigger: ['blur', 'change'] }],
    whHeight: [
        { required: true, message: '请输入仓库净高', trigger: ['blur', 'change'] },
        { validator: whHeightValidator, trigger: ['blur', 'change'] },
    ],
    whType: [{ required: true, message: '请选择仓库类型', trigger: ['blur', 'change'] }],
    officeFlag: [{ required: true, message: '请选择是否有办公室', trigger: ['blur', 'change'] }],
    dormFlag: [{ required: true, message: '请选择是否有员工宿舍', trigger: ['blur', 'change'] }],
    buildingType: [{ required: true, message: '请选择建筑类型', trigger: ['blur', 'change'] }],
    parkPath: [{ required: true, message: '请选择选择园区通道', trigger: ['blur', 'change'] }],
    // securitySystemFlag: [{ required: true, message: '请选择保安系统', trigger: ['blur', 'change'] }],
    poweredSystemFlag: [{ required: true, message: '请选择备用发电机', trigger: ['blur', 'change'] }],
    specificPower: [
        { required: true, message: '请输入具体功率', trigger: ['blur', 'change'] },
        { validator: specificPowerValidator, trigger: ['blur', 'change'] },
    ],
    fireInspection: [{ required: true, message: '请选择消防验收', trigger: ['blur', 'change'] }],
    fireFacilities: [{ required: true, message: '请选择消防设施', trigger: ['blur', 'change'] }],
    platform: [{ required: true, message: '请选择月台', trigger: ['blur', 'change'] }],
    canopy: [{ required: true, message: '请选择雨棚', trigger: ['blur', 'change'] }],
    loadingPlatform: [{ required: true, message: '请选择装卸平台', trigger: ['blur', 'change'] }],
    pressure: [{ required: true, message: '请选择地面承压', trigger: ['blur', 'change'] }],
    groundDust: [{ required: true, message: '请选择地面防尘', trigger: ['blur', 'change'] }],
    lightingSystem: [{ required: true, message: '请选择照明系统', trigger: ['blur', 'change'] }],
    withLighting: [{ required: true, message: '请选择采光带占比', trigger: ['blur', 'change'] }],
    cityDistance: [
        { required: true, message: '请输入离市区的距离', trigger: ['blur', 'change'] },
        { validator: cityDistanceValidator, trigger: ['blur', 'change'] },
    ],
    companyName: [{ required: true, message: '请选择分公司', trigger: ['blur', 'change'] }],
    cityName: [{ required: true, message: '请选择城市', trigger: ['blur', 'change'] }],
    fireUnitArea: [
        { required: true, message: '请输入消防单元面积', trigger: ['blur', 'change'] },
        { validator: fireUnitAreaValidator, trigger: ['blur', 'change'] },
    ],
    unitPrice: [
        { required: true, message: '请输入单价', trigger: ['blur', 'change'] },
        { pattern: /^([1-9]\d{1,5}|\d)(\.\d{1,2})?$/, message: '请输入0-999999.99，', trigger: ['blur', 'change'] },
    ],
    contacts: [
        { required: true, message: '请输入联系人', trigger: ['blur', 'change'] },
        { max: 20, message: '联系人不能超过20个字符', trigger: ['blur', 'change'] },
    ],
    contactsPhone: [
        { required: true, message: '请输入联系人电话', trigger: ['blur', 'change'] },
        {
            pattern:
                // eslint-disable-next-line max-len
                /^(((13[0-9]{1})|(14[0-9]{1})|(15[0-9]{1})|(16[0-9]{1})|(17[0-9]{1})|(19[0-9]{1})|(18[0-9]{1}))+\d{8})$/,
            message: '请输入正确的电话！',
            trigger: ['blur', 'change'],
        },
    ],
    factoryFlag: [{ required: true, message: '请选择是否地产商', trigger: ['blur', 'change'] }],
    factorySign: [{ required: true, message: '请选择地产商简称', trigger: ['blur', 'change'] }],
    warehouseLevel: [{ required: true, message: '请选择仓库等级', trigger: ['blur', 'change'] }],
    lessorName: [
        { required: true, message: '请输入出租方名称', trigger: ['blur', 'change'] },
        { max: 60, message: '不能超过60个字符', trigger: ['blur', 'change'] },
    ],
    tenantName: [
        { required: true, message: '请输入承租方名称', trigger: ['blur', 'change'] },
        { max: 60, message: '不能超过60个字符', trigger: ['blur', 'change'] },
    ],
    landUse: [{ required: true, message: '请选择土地用途', trigger: ['blur', 'change'] }],
    landProperty: [{ required: true, message: '请选择土地性质', trigger: ['blur', 'change'] }],
    isSublet: [{ required: true, message: '请选择是否涉及转租', trigger: ['blur', 'change'] }],
    propertyQualificationFlag: [{ required: true, message: '请选择是否有产权证或报建3证', trigger: ['blur', 'change'] }],
}

export const form = {
    whStatus: '0',
    approveStatus: '',
    contractStatus: '',
    specialApproveFlag: '',
    whName: '',
    propertyType: '',
    propertyOwner: '',
    manageType: '',
    addressCode: '',
    whAddress: '',
    whSquare: '',
    rentableArea: '',
    usableArea: '',
    whType: '',
    poweredSystemFlag: '',
    specificPower: '',
    whHeight: '',
    fireInspection: '',
    fireFacilities: '',
    fireUnitArea: '',
    platform: '',
    canopy: '',
    pressure: '',
    buildingType: '',
    parkPath: '',
    withLighting: '',
    cityDistance: '',
    groundDust: '',
    lightingSystem: '',
    officeFlag: '',
    dormFlag: '',
    // securitySystemFlag: '',
    companyName: '',
    cityName: '',
    factoryFlag: '',
    factorySign: '',
    warehouseLevel: '',
    lessorName: '',
    tenantName: '',
    landUse: '',
    landProperty: '',
    isSublet: '',
    leaseFileList: [],
    // platformWarehouseFileUrl: '',
    warehouseFileUrl: '', // 仓库评审方案
    warehouseInfoFileUrl: '', // 仓库寻源信息登记表
    warehouseOtherFileUrl: '', // 其他附件（可打包）
    propertyQualificationFlag: '',
}

export const qualificationForm = {
    id: '',
    whCode: '',
    qualificationName: '',
    certificateBeginDate: '',
    certificateEndDate: '',
    fileName: '',
    fileUrl: '',
    qualificationTypeCode: '',
    qualificationType: '',
    certificateNo: '',
}

export const imagesList = {
    whCode: '',
    qualificationInfos: [],
}

// 物理仓仓库状态
export const WH_STATUS = {
    ADD: '0', // 新增
    QUALIFIED: '1', // 合格
    FORBIDDEN: '2', // 停用
    ENABLE: '3', // 启用
    REJECT: '4', // 驳回
    ABANDONED: '5', // 废弃
    PENDING_APPROVAL: '6', // 待审批
}

// 物理仓审批状态
export const WH_AUDIT_STATUS = {
    DRAFT: '1', // 草稿
    APPROVALING: '2', // 审批中
    APPROVED: '3', // 审批通过
    REJECT: '4', // 驳回
    ABANDONED: '5', // 废弃
}
